import { Modal } from "antd";
import { useEffect, useState } from "react";
import { isIOS } from "react-device-detect";
import { ReactComponent as Report } from "../../../../assets/images/icon/report.svg";

interface IProps {
    isOpen: boolean
    setIsOpen: Function
    onClick?: Function
}

const bottomOption = { id: 1, label: '신고', value: 1 };


const NotMyfeedAndCommentBottomSheet = ({ isOpen, setIsOpen, onClick }: IProps) => {
    const [bodyHeight, setBodyHeight] = useState<number>(72);

    useEffect(() => {
        setBodyHeight(72 + (isIOS ? 34 : 0))
    }, [isIOS, isOpen])

    return <>
        <Modal transitionName="custom-modal"
            style={{ top: `calc(100vh - ${bodyHeight}px)`, padding: 0, margin: 0 }}
            styles={{ content: { width: '100vw', height: bodyHeight, maxWidth: '480px', overflow: "scroll", borderRadius: "var(--radius16) var(--radius16) 0 0", padding: 0 }, body: { paddingBottom: isIOS ? 34 : 0 } }}
            open={isOpen} closeIcon={null} footer={null} onCancel={() => { setIsOpen(false) }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: "var(--space20) var(--space20)" }} onClick={() => { setIsOpen(false); onClick?.(bottomOption.id) }}>
                <Report width={16} height={16} stroke="var(--secondarys400)" fill="var(--secondarys400)" style={{ padding: '8px' }} />
                <div className='body/b3 secondary/s800' >
                    {bottomOption.label}
                </div>
            </div>
        </Modal>
    </>
}

export { NotMyfeedAndCommentBottomSheet };


